/**
 * CRM display helpers (AK-49) — форматирование дат и метки типов активностей.
 */
import type { CrmActivityType } from './types';

export const ACTIVITY_TYPE_LABEL: Record<CrmActivityType, string> = {
  visit: 'Визит',
  call: 'Звонок',
  email: 'Email',
  meeting: 'Встреча',
};

export const ACTIVITY_TYPE_OPTIONS: Array<{
  value: CrmActivityType;
  label: string;
}> = [
  { value: 'visit', label: 'Визит' },
  { value: 'call', label: 'Звонок' },
  { value: 'email', label: 'Email' },
  { value: 'meeting', label: 'Встреча' },
];

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** «2 дня назад» / «неделю назад» — относительная давность последнего контакта. */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return 'нет активности';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const diffMs = Date.now() - d.getTime();
  const day = 24 * 60 * 60 * 1000;
  const days = Math.floor(diffMs / day);
  if (days <= 0) return 'сегодня';
  if (days === 1) return 'вчера';
  if (days < 7) return `${days} дн. назад`;
  if (days < 14) return 'неделю назад';
  if (days < 31) return `${Math.floor(days / 7)} нед. назад`;
  if (days < 365) return `${Math.floor(days / 30)} мес. назад`;
  return formatDate(iso);
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
